const countries = state => state.countries
const country = state => state.country

export default {
  countries,
  country
};
